module.exports = __webpack_public_path__ + "img/caselist15.d2b8f297.jpg";